import { render, staticRenderFns } from "./outImage.vue?vue&type=template&id=3850932a&scoped=true"
import script from "./outImage.vue?vue&type=script&lang=js"
export * from "./outImage.vue?vue&type=script&lang=js"
import style0 from "./outImage.vue?vue&type=style&index=0&id=3850932a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3850932a",
  null
  
)

export default component.exports